package com.example.mystybag.login.views

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.ui.components.custom.DefaultCircleShapedTextField
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.login.logic.StaffForgotPasswordEmailViewModel
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.ui.theme.LocalTheme.p8

@Composable
fun StaffForgotPasswordEmailView(viewModel: StaffForgotPasswordEmailViewModel) {
    val keyboardController = LocalSoftwareKeyboardController.current
    val uiState = viewModel.uiState.subscribeAsState()
    val theme = AppTheme.current

    BottomSheetUIView(
        viewModel = viewModel,
        bottomSheetFactory = {}
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .padding(horizontal = p16),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = p32, bottom = p24),
                contentAlignment = Alignment.CenterStart
            ) {
                Texts.DisplaySmall(
                    text = stringResource(SR.strings.forgot_password),
                    color = theme.colors.onSurface,
                )
            }

            DefaultCircleShapedTextField(
                modifier = Modifier.fillMaxWidth(),
                value = uiState.value.email,
                label = stringResource(SR.strings.email),
                errorText = uiState.value.emailErrorMsg,
                onValueChange = viewModel::onEmailChange,
                isError = uiState.value.emailIsError,
                inputType = TextFieldType.EMAIL,
                keyboardOptions = KeyboardOptions(
                    keyboardType = KeyboardType.Email,
                    imeAction = ImeAction.Done
                )
            )

            Spacer(Modifier.weight(1f))

            DefaultButton(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = p8),
                caption = stringResource(SR.strings.continue_camel_case),
                callback = {
                    keyboardController?.hide()
                    viewModel.onContinue()
                },
                identifier = "Staff Forgot Password Continue"
            )
        }
    }
}
